import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyHint } from '@/components/KeyHint';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface SearchPlaceholderProps {
    focused: boolean;
    showShortcut?: boolean;
}

export function SearchPlaceholder({
    focused,
    showShortcut = true,
}: SearchPlaceholderProps) {
    const { t } = useTranslation(I18nNamespace.COMMON);

    return (
        <div className="pointer-events-none absolute left-0 top-0 flex h-5 max-w-full items-center gap-2 whitespace-nowrap font-geist">
            <span className="min-w-0 truncate text-sm font-normal leading-5 text-grey-300">
                {t('promptInput.placeholder')}
            </span>
            {!focused && showShortcut && (
                <KeyHint theme="dark" className="shrink-0">
                    {t('promptInput.focusShortcut')}
                </KeyHint>
            )}
        </div>
    );
}
